<div *ngIf="requestUser" class="inputContainer" [ngClass]="{'inputContainerMobile': isMobile}">
  <mat-form-field class="propertyInput flex1" *ngIf="displayProperty">
    <mat-label [ngClass]="{'disabled' : noPropertiesFlag}" >{{'FORM.REQUEST_FORM.PROPERTY_INPUT_PLACEHOLDER' | translate}}</mat-label>
    <mat-select
      *ngIf="displayProperty && !oneProperty"
      [formControl]="property"
      [ngClass]="{'errorBorder': property.errors?.['required'] && property.dirty,'disabled' : noPropertiesFlag}"
    >
      <mat-option *ngFor="let item of propertiesList" [value]="item.propertyId">
        {{item.address}}
      </mat-option>
    </mat-select>

    <input class="oneProperty" *ngIf="oneProperty" type="text" matInput [formControl]="property" autocomplete="off" placeholder="" [ngClass]="{'errorBorder': property.errors?.['required'] && property.dirty,'disabled' : noPropertiesFlag, 'mobileInput': isMobile}" />
    <mat-error *ngIf="property.errors?.['required']">{{'ERROR.REQUIRED' | translate}}</mat-error>
  </mat-form-field>

  <div class="checkBoxContainer flex1" *ngIf="displayProperty">
    <mat-checkbox class="example-margin"
                  (change)="noPropertiesSelected($event.checked)"
                  [checked]="noPropertiesFlag">
    </mat-checkbox>
    <div class="checkBoxText">
      {{'FORM.REQUEST_FORM.CHECK_BOX_PLACEHOLDER' | translate}}
    </div>
  </div>

  <mat-form-field class="flex1" >
    <mat-label [ngClass]="{'mobileLabel ': isMobile}">{{'FORM.REQUEST_FORM.CATAGORY_INPUT_PLACEHOLDER' | translate}}</mat-label>
    <mat-select [formControl]="category" class="select_input" [ngClass]="{'errorBorder': category.errors?.['required'] && category.dirty,'mobile_select' : isMobile}">
      <mat-option *ngFor="let item of serviceCategories$ | async" [value]="item.label" [ngClass]="{'mobile_select' : isMobile}">
        {{item.label}}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="category.errors?.['required']">{{'ERROR.REQUIRED' | translate}}</mat-error>
  </mat-form-field>

  <mat-form-field class="flex1" >
    <mat-label [ngClass]="{'mobileLabel ': isMobile}">{{'FORM.REQUEST_FORM.REQUEST_INPUT_PLACEHOLDER' | translate}}</mat-label>
    <textarea (keyup)="autoGrowTextZone($event)" rows="1" matInput [formControl]="request" autocomplete="off" placeholder="" [ngClass]="{'errorBorder': request.errors?.['required'] && request.dirty,'mobileTextarea': isMobile,'bigInput' : !directForm}"></textarea>
    <mat-error *ngIf="request.errors?.['required']">{{'ERROR.REQUIRED' | translate}}</mat-error>
  </mat-form-field>

  <div class="uploadFileContainer" *ngIf="directForm">
    <div class="upload-file-label">{{'FORM.REQUEST_FORM.FILE.UPLOAD_FILE_PLACEHOLDER' | translate}}</div>
    <ng-container *ngIf="!fileToUpload.value else editFile">
      <label class="pointer" for="upload-file" >
        <div class="file-box">
          <i class="file-icon fa-light fa-paperclip"></i>
          <span class="upload-file-title bolder as-link">{{'FORM.REQUEST_FORM.FILE.CHOOSE_FILE' | translate}}</span>
        </div>
      </label>
    </ng-container>
    <input
      #fileInput
      (change)="handleFileInput($event.target)"
      hidden
      id="upload-file"
      type="file">
  </div>

</div>


<ng-template #editFile>
  <div class="file-box flex center">
    <div class="file-box-display" *ngIf="!loading" >
      <div class="file-data">
        <div [ngSwitch]="fileToUploadType">
          <img *ngSwitchCase="'image'" class="file-preview" src="{{fileToUpload.value?.src}}" alt="" (click)="openViewer()">
          <i *ngSwitchCase="'pdf'" class="fa-light fa-file-pdf"></i>
          <i *ngSwitchCase="'video'" class="fa-light file-video"></i>
        </div>
       
        <div class="upload-file-title bolder as-link" (click)="openViewer()">{{fileToUpload.value?.name | truncate: 50}}</div>
      </div>
      <div class="file-actions flex">
        <i class="fa-light fa-close" (click)="clearFile()"></i>
        <!-- <label class="upload-file-title bolder pointer margin-right"
               for="change-file"
        >{{'FORM.REQUEST_FORM.FILE.REPLACE_FILE' | translate}}</label>
        <label (click)="clearFile()"
               class="upload-file-title bolder pointer"
        >{{'FORM.REQUEST_FORM.FILE.DELETE_FILE' | translate}}</label> -->
      </div>
    </div>
  </div>
  <input (change)="handleFileInput($event.target)" hidden id="change-file" type="file"/>
</ng-template>

